import type { WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS } from '../../../view/whiteboards-entrypoint-experiment/constants';

export const CONFLUENCE_ACCESS_ESTABLISHED =
	'state.actions.permissions.CONFLUENCE_ACCESS_ESTABLISHED' as const;

export type HasConfluenceAccessEstablishedAction = {
	type: typeof CONFLUENCE_ACCESS_ESTABLISHED;
	payload: {
		hasConfluenceAccess: boolean;
	};
};

export const hasConfluenceAccessEstablished = (
	hasConfluenceAccess: boolean,
): HasConfluenceAccessEstablishedAction => ({
	type: CONFLUENCE_ACCESS_ESTABLISHED,
	payload: {
		hasConfluenceAccess,
	},
});

export const HAS_CONFLUENCE_SPACES = 'state.actions.HAS_CONFLUENCE_SPACES' as const;

export type HasConfluenceSpacesEstablishedAction = {
	type: typeof HAS_CONFLUENCE_SPACES;
	payload: {
		hasConfluenceSpaces: boolean;
	};
};

export const hasConfluenceSpacesEstablished = (
	hasConfluenceSpaces: boolean,
): HasConfluenceSpacesEstablishedAction => ({
	type: HAS_CONFLUENCE_SPACES,
	payload: {
		hasConfluenceSpaces,
	},
});

export const PULSE_VIEWED_ESTABLISHED =
	'state.actions.permissions.PULSE_VIEWED_ESTABLISHED' as const;

export type HasPulseViewedEstablishedAction = {
	type: typeof PULSE_VIEWED_ESTABLISHED;
	payload: {
		hasViewedPulse: boolean;
	};
};

export const hasPulseViewedEstablished = (
	hasViewedPulse: boolean,
): HasPulseViewedEstablishedAction => ({
	type: PULSE_VIEWED_ESTABLISHED,
	payload: {
		hasViewedPulse,
	},
});

export const SET_HAS_PULSE_VIEWED_REQUEST =
	'state.actions.permissions.SET_HAS_PULSE_VIEWED_REQUEST' as const;

export type SetHasViewedPulseRequestAction = {
	type: typeof SET_HAS_PULSE_VIEWED_REQUEST;
};

export const setHasViewedPulseRequest = (): SetHasViewedPulseRequestAction => ({
	type: SET_HAS_PULSE_VIEWED_REQUEST,
});

export const SET_HAS_PULSE_VIEWED_SUCCESS =
	'state.actions.permissions.SET_HAS_PULSE_VIEWED_SUCCESS' as const;

export type SetHasViewedPulseSuccessAction = {
	type: typeof SET_HAS_PULSE_VIEWED_SUCCESS;
	payload: {
		hasViewedPulse: boolean;
	};
};

export const setHasViewedPulseSuccess = (
	hasViewedPulse: boolean,
): SetHasViewedPulseSuccessAction => ({
	type: SET_HAS_PULSE_VIEWED_SUCCESS,
	payload: {
		hasViewedPulse,
	},
});

export const SET_HAS_PULSE_VIEWED_FAILURE =
	'state.actions.permissions.SET_HAS_PULSE_VIEWED_FAILURE' as const;

export type SetHasViewedPulseFailureAction = {
	type: typeof SET_HAS_PULSE_VIEWED_FAILURE;
};

export const setHasViewedPulseFailure = (): SetHasViewedPulseFailureAction => ({
	type: SET_HAS_PULSE_VIEWED_FAILURE,
});

export const SET_WHITEBOARD_ELIGIBILITY =
	'state.actions.permissions.SET_WHITEBOARD_ELIGIBILITY' as const;

export type SetWhiteboardEligibilityAction = {
	type: typeof SET_WHITEBOARD_ELIGIBILITY;
	payload: {
		flow: 'coUse' | 'crossFlow';
		cohort: WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS | string;
	};
};

export const setWhiteboardEligibility = ({
	flow,
	cohort,
}: {
	flow: 'coUse' | 'crossFlow';
	cohort: WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS | string;
}): SetWhiteboardEligibilityAction => ({
	type: SET_WHITEBOARD_ELIGIBILITY,
	payload: {
		flow,
		cohort,
	},
});

export type Action =
	| HasConfluenceAccessEstablishedAction
	| HasConfluenceSpacesEstablishedAction
	| HasPulseViewedEstablishedAction
	| SetHasViewedPulseRequestAction
	| SetHasViewedPulseSuccessAction
	| SetHasViewedPulseFailureAction
	| SetWhiteboardEligibilityAction;
